import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import AuthLayout from '../components/layout/AuthLayout.jsx';
import api from '../lib/api.js';

export default function ForgotPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  async function submit(e) {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await api.post('/auth/forgot', { email });
      setSubmitted(true);
    } catch (err) {
      setError(err?.message || 'Errore');
    } finally {
      setLoading(false);
    }
  }

  return (
    <AuthLayout
      title="Recupera accesso"
      subtitle="Procedura per utenti con account smarrito"
      footer={
        <div className="space-y-1">
          <p>Conosci già il tuo PIN o la tua password?</p>
          <p className="space-x-2">
            <Link to="/reset-password" className="text-brand-300 hover:underline">Cambia password</Link>
            <span aria-hidden="true">·</span>
            <Link to="/reset-pin" className="text-brand-300 hover:underline">Cambia PIN</Link>
          </p>
        </div>
      }
    >
      {!submitted ? (
        <form onSubmit={submit} className="space-y-3">
          <div className="flex flex-col gap-1">
            <label className="text-xs text-surface-4" htmlFor="forgot-email">Email utilizzata per la registrazione *</label>
            <input id="forgot-email" className="input" type="email" autoComplete="email" autoFocus required value={email} onChange={e => setEmail(e.target.value)} />
          </div>
          {error && <div className="rounded-md border border-danger/30 bg-danger/10 px-3 py-2 text-xs text-danger">{error}</div>}
          <button type="submit" className="btn btn-primary w-full" disabled={loading}>{loading ? 'Invio...' : 'Procedi'}</button>
          <button type="button" className="btn btn-ghost w-full text-xs" onClick={() => navigate('/login')}>Torna al login</button>
        </form>
      ) : (
        <div className="space-y-3 text-sm">
          <p>Scrivi una mail a <strong>info@arcanetechpro.it</strong> indicando l'indirizzo email utilizzato per registrarsi.</p>
          <p className="text-warning">Entro 2 giorni lavorativi riceverai le nuove credenziali di accesso tramite posta elettronica.</p>
          <button type="button" className="btn btn-primary w-full" onClick={() => navigate('/login')}>Torna al login</button>
        </div>
      )}
    </AuthLayout>
  );
}